import {createApi} from '@reduxjs/toolkit/query/react';
import {
  LoginRequest,
  LoginResponse,
  SignupRequest,
  StudentSignupRequest,
  TutorSignupRequest,
  ForgotPasswordRequest,
  ForgotPasswordResponse,
} from '../../types/authTypes';
import { baseQuery } from './baseQuery';

// Create the API slice
export const authApi = createApi({
  reducerPath: 'authApi',
  baseQuery,
  endpoints: builder => ({
    login: builder.mutation<LoginResponse, LoginRequest>({
      query: credentials => ({
        url: '/auth/login',
        method: 'POST',
        body: credentials,
      }),
    }),
    signup: builder.mutation<LoginResponse, SignupRequest>({
      query: userData => ({
        url: '/auth/signup',
        method: 'POST',
        body: userData,
      }),
    }),
    signupTutor: builder.mutation<LoginResponse, TutorSignupRequest>({
      query: tutorData => ({
        url: '/auth/signup/tutor',
        method: 'POST',
        headers: {
          accept: '*/*',
          'Content-Type': 'application/json',
        },
        body: tutorData,
      }),
    }),
    signupStudent: builder.mutation<LoginResponse, StudentSignupRequest>({
      query: studentData => ({
        url: '/auth/signup/student',
        method: 'POST',
        headers: {
          accept: '*/*',
          'Content-Type': 'application/json',
        },
        body: studentData,
      }),
    }),
    forgotPassword: builder.mutation<ForgotPasswordResponse, ForgotPasswordRequest>({
      query: forgotPasswordData => ({
        url: '/auth/forgot-password',
        method: 'POST',
        headers: {
          accept: '*/*',
          'Content-Type': 'application/json',
        },
        body: forgotPasswordData,
      }),
    }),
    generateEmailOtp: builder.mutation<void, { email: string; purpose: string }>({
      query: ({ email, purpose }) => ({
        url: '/otp/genEmailOtp',
        method: 'POST',
        headers: {
          accept: '*/*',
          'Content-Type': 'application/json',
        },
        body: { email, purpose },
      }),
    }),
    validateEmailOtp: builder.mutation<any, { email: string; otp: string }>({
      query: ({ email, otp }) => ({
        url: '/otp/validateEmailOtp',
        method: 'POST',
        headers: {
          accept: '*/*',
          'Content-Type': 'application/json',
        },
        body: { email, otp },
        validateStatus: (response) => {
          // Accept both 200 and 201 as successful responses
          return response.status === 200 || response.status === 201;
        },
      }),
      transformResponse: (response: any, meta) => {
        // For 201 with no body, return a success indicator
        if (!response && meta?.response?.status === 201) {
          return { success: true };
        }
        // Otherwise return the response as-is
        return response || { success: true };
      },
    }),
  }),
});

export const {
  useLoginMutation,
  useSignupMutation,
  useSignupTutorMutation,
  useSignupStudentMutation,
  useForgotPasswordMutation,
  useGenerateEmailOtpMutation,
  useValidateEmailOtpMutation,
} = authApi;
